<template>
  <div class='PropValue'
  v-if="data.active && estoque.map(e => parseFloat(e.quantidade)).reduce((p, c) => c + p, 0) > 0"
  :class="{ marginValue: chave > 0, selected: data.selected }"
  @click="$emit('update:value', data)"
  >
    {{ data.name }}
  </div>
  <div v-if="chave === 0 && estoque.map(e => parseFloat(e.quantidade)).reduce((p, c) => c + p, 0) <= 0" class="sold-out">Esgotado</div>
</template>

<script>
export default {
  name: 'PropValue',
  props: ['data', 'chave', 'estoque']
}
</script>

<style scoped>
.PropValue {
  padding: 2%;
  background-color: #CCCCCC;
  border-radius: 5px;
  cursor: pointer;
}

.marginValue {
  margin-left: 2%;
}

.selected {
  background-color: #333333;
  color: #FFFFFF
}

.sold-out {
  width: max-content;
  font-size: 10px;
  color: #FFFFFF;
  padding: 5px;
  background-color: red;
  border-radius: 5px;
  border: 2px solid #FFFFFF;
}
</style>
